import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Easing,
	Interactive,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';
import {CloseUpFrame} from './CloseUpFrame';

const TimelineSourceOnlyTrimWideContent = () => {
	const {fps} = useVideoConfig();
	// Keep the camera, cursor, and recording on the captured 60 fps clock.
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<Interactive.Div
			name="Close-up to wide camera"
			style={{
				position: 'absolute',
				inset: 0,
				backgroundColor: '#1f2427',
				// Hold the trim close-up before gradually revealing the changing preview.
				scale: interpolate(frame, [140, 230], [2.4, 1], {
					extrapolateLeft: 'clamp',
					extrapolateRight: 'clamp',
					easing: Easing.bezier(0.2, 0, 0.2, 1),
					output: 'perceptual-scale',
				}),
				translate: interpolate(
					frame,
					[140, 230],
					['-336px -864px', '0px 0px'],
					{
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
						easing: Easing.bezier(0.2, 0, 0.2, 1),
					},
				),
			}}
		>
			<AbsoluteFill
				name="Canvas Capture"
				durationInFrames={(431 / 60) * fps}
				style={{
					width: 2820,
					height: 2348,
					translate: '-480px -540px',
					scale: 0.65,
					rotate: '0.85 -0.35 0.1 32deg',
				}}
			>
				<Video
					src="https://remotion.media/studio-close-ups/timeline-source-only-trim-wide-b0439388cc61.mp4"
					durationInFrames={(431 / 60) * fps}
					muted
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor={interpolate(
						frame,
						[21, 65, 326, 328, 330, 333, 334],
						['auto', 'custom', 'auto', 'custom', 'auto', 'custom', 'auto'],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					customCursor={interpolate(
						frame,
						[65, 333],
						[
							'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E") 2 12, ew-resize',
							'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20transform%3D%22translate(32%200)%20scale(-1%201)%22%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							frame,
							[0, 103, 282, 384, 388],
							[3.7, 3.33, 3.7, 3.33, 3.7],
							{
								easing: Easing.step1,
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							frame,
							[
								21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
								37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
								53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68,
								69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 82, 83, 134, 135,
								139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151,
								152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164,
								165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177,
								178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190,
								191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203,
								204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216,
								217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229,
								230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242,
								243, 244, 245, 246, 247, 248, 249, 325, 326, 327, 328, 329, 330,
								331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343,
								344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356,
								357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369,
								370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380,
							],
							[
								'2894.52734375px 298.68828125px',
								'2894.52734375px 318.127734375px',
								'2881.40390625px 347.872265625px',
								'2869.14765625px 372.3703125px',
								'2844.6351562500004px 421.36640625px',
								'2811.696484375px 482.04062500000003px',
								'2770.331640625px 559.552734375px',
								'2679.1179687500003px 717.930078125px',
								'2612.966015625px 813.7109375px',
								'2537.809765625px 920.129296875px',
								'2460.2253906250003px 1010.201171875px',
								'2382.641015625px 1100.273046875px',
								'2302.628515625px 1174.533203125px',
								'2231.605859375px 1239.803515625px',
								'2161.0890625px 1299.9574218750001px',
								'2119.14609375px 1329.066015625px',
								'2061.62265625px 1371.5726562500001px',
								'2016.6878906250001px 1400.146484375px',
								'1998.95390625px 1410.76953125px',
								'1974.44140625px 1423.011328125px',
								'1974.44140625px 1423.011328125px',
								'1872.6625000000001px 1486.50390625px',
								'1857.8046875px 1493.9183593750001px',
								'1838.3363281250001px 1501.8675781250001px',
								'1823.478515625px 1511.753515625px',
								'1808.620703125px 1519.16796875px',
								'1789.15234375px 1527.1171875px',
								'1769.6839843750001px 1538.0726562500001px',
								'1727.87109375px 1557.1796875px',
								'1703.7921875000002px 1569.2046875px',
								'1677.5597656250002px 1585.8402343750001px',
								'1651.3273437500002px 1602.4757812500002px',
								'1636.46953125px 1612.3617187500001px',
								'1629.040625px 1614.8332031250002px',
								'1616.29296875px 1623.11484375px',
								'1613.4601562500002px 1624.5167968750002px',
								'1610.6273437500001px 1627.3207031250001px',
								'1605.30859375px 1630.6593750000002px',
								'1599.98984375px 1633.998046875px',
								'1592.18515625px 1639.8226562500001px',
								'1586.8664062500002px 1645.1125000000002px',
								'1583.498828125px 1650.40234375px',
								'1578.1800781250001px 1653.741015625px',
								'1572.861328125px 1662.91875px',
								'1568.958984375px 1664.85546875px',
								'1565.59140625px 1670.1453125px',
								'1564.1750000000002px 1672.94921875px',
								'1561.3421875000001px 1675.7531250000002px',
								'1559.92578125px 1678.5570312500001px',
								'1558.509375px 1679.958984375px',
								'1557.0929687500002px 1682.7628906250002px',
								'1557.0929687500002px 1684.16484375px',
								'1555.9222656250001px 1686.47734375px',
								'1554.505859375px 1687.8792968750001px',
								'1554.505859375px 1690.683203125px',
								'1554.505859375px 1693.487109375px',
								'1553.089453125px 1696.291015625px',
								'1553.089453125px 1697.447265625px',
								'1553.089453125px 1698.5023437500001px',
								'1553.089453125px 1698.5023437500001px',
								'1552.12109375px 1698.5023437500001px',
								'1552.12109375px 1698.5023437500001px',
								'1551.6730468750002px 1698.5023437500001px',
								'1551.6730468750002px 1698.5023437500001px',
								'1550.748046875px 1698.5023437500001px',
								'1550.748046875px 1698.5023437500001px',
								'1549.75078125px 1698.5023437500001px',
								'1548.65234375px 1698.5023437500001px',
								'1547.597265625px 1698.5023437500001px',
								'1547.597265625px 1698.5023437500001px',
								'1544.128515625px 1698.5023437500001px',
								'1541.2523437500001px 1698.5023437500001px',
								'1538.3328125px 1698.5023437500001px',
								'1531.2796875000001px 1701.0316406250001px',
								'1528.7648437500002px 1701.7109375px',
								'1516.9132812500002px 1704.7316406250002px',
								'1512.9386718750002px 1706.6828125000002px',
								'1505.1339843750002px 1708.6195312500001px',
								'1496.722265625px 1710.975390625px',
								'1496.722265625px 1710.975390625px',
								'1485.9691406250001px 1714.28515625px',
								'1477.2250000000001px 1716.453125px',
								'1471.689453125px 1717.3203125px',
								'1471.689453125px 1717.3203125px',
								'1463.4222656250001px 1718.144140625px',
								'1455.155078125px 1720.023046875px',
								'1450.9347656250002px 1721.034765625px',
								'1448.275390625px 1722.0031250000002px',
								'1440.3839843750002px 1723.9398437500001px',
								'1438.3460937500001px 1724.6625000000001px',
								'1430.584765625px 1726.42578125px',
								'1423.4738281250002px 1727.2640625000001px',
								'1423.4738281250002px 1727.2640625000001px',
								'1412.633984375px 1729.417578125px',
								'1405.783203125px 1730.573828125px',
								'1405.783203125px 1730.573828125px',
								'1397.8773437500001px 1732.452734375px',
								'1390.983203125px 1733.88359375px',
								'1384.421484375px 1734.5773437500002px',
								'1382.5859375px 1735.27109375px',
								'1374.1019531250001px 1735.27109375px',
								'1365.5890625px 1736.557421875px',
								'1362.799609375px 1736.6296875px',
								'1357.9867187500001px 1738.060546875px',
								'1355.61640625px 1738.060546875px',
								'1347.5804687500001px 1738.7109375px',
								'1341.900390625px 1739.43359375px',
								'1331.421875px 1741.3703125000002px',
								'1328.7625px 1741.3703125000002px',
								'1326.103125px 1742.338671875px',
								'1318.1828125px 1743.3070312500001px',
								'1308.860546875px 1745.0703125px',
								'1308.860546875px 1745.0703125px',
								'1299.48046875px 1746.905859375px',
								'1289.9847656250001px 1747.975390625px',
								'1289.9847656250001px 1747.975390625px',
								'1280.358984375px 1749.059375px',
								'1274.8234375px 1750.432421875px',
								'1268.1605468750001px 1751.155078125px',
								'1262.841796875px 1751.8488281250002px',
								'1257.436328125px 1753.236328125px',
								'1255.6296875px 1753.77109375px',
								'1248.4320312500001px 1754.623828125px',
								'1248.4320312500001px 1754.623828125px',
								'1239.9625px 1756.5460937500002px',
								'1237.1875px 1757.35546875px',
								'1234.2390625px 1758.74296875px',
								'1232.76484375px 1758.7863281250002px',
								'1225.94296875px 1760.7375000000002px',
								'1221.8671875px 1761.705859375px',
								'1217.3578125000001px 1762.6742187500001px',
								'1212.487109375px 1763.787109375px',
								'1207.052734375px 1764.7843750000002px',
								'1201.560546875px 1765.8539062500001px',
								'1196.025px 1765.96953125px',
								'1190.518359375px 1767.255859375px',
								'1185.01171875px 1767.35703125px',
								'1179.51953125px 1768.715625px',
								'1167.653515625px 1768.7445312500001px',
								'1162.334765625px 1768.7445312500001px',
								'1154.530078125px 1770.68125px',
								'1148.3296875px 1770.68125px',
								'1144.48515625px 1770.68125px',
								'1138.6605468750001px 1771.447265625px',
								'1133.0671875px 1772.458984375px',
								'1127.040234375px 1772.56015625px',
								'1125.5515625px 1773.19609375px',
								'1118.657421875px 1773.9476562500001px',
								'1117.2699218750001px 1773.9476562500001px',
								'1114.5238281250001px 1773.9476562500001px',
								'1113.107421875px 1775.3351562500002px',
								'1110.49140625px 1775.3351562500002px',
								'1109.436328125px 1775.3351562500002px',
								'1108.1644531250001px 1775.3351562500002px',
								'1106.748046875px 1775.3351562500002px',
								'1104.348828125px 1775.3351562500002px',
								'1103.0335937500001px 1775.3351562500002px',
								'1101.76171875px 1775.3351562500002px',
								'1100.54765625px 1775.3351562500002px',
								'1099.3625px 1775.9132812500002px',
								'1096.659765625px 1776.4914062500002px',
								'1095.474609375px 1776.4914062500002px',
								'1093.191015625px 1776.4914062500002px',
								'1091.774609375px 1776.4914062500002px',
								'1090.416015625px 1776.4914062500002px',
								'1087.727734375px 1776.4914062500002px',
								'1086.398046875px 1776.4914062500002px',
								'1085.0394531250001px 1776.4914062500002px',
								'1085.0394531250001px 1776.4914062500002px',
								'1083.767578125px 1776.4914062500002px',
								'1082.640234375px 1777.01171875px',
								'1082.640234375px 1777.01171875px',
								'1081.628515625px 1777.53203125px',
								'1080.616796875px 1777.53203125px',
								'1080.616796875px 1777.53203125px',
								'1081.512890625px 1781.130859375px',
								'1088.92734375px 1786.073828125px',
								'1154.515625px 1847.5863281250001px',
								'1154.515625px 1847.5863281250001px',
								'1273.8984375px 1923.7109375px',
								'1298.396484375px 1935.952734375px',
								'1413.42890625px 1975.6410156250001px',
								'1506.174609375px 2002.552734375px',
								'1610.1214843750001px 2019.1449218750001px',
								'1712.941015625px 2030.5628906250001px',
								'1815.760546875px 2041.9808593750001px',
								'1918.580078125px 2041.9808593750001px',
								'2011.32578125px 2041.9808593750001px',
								'2104.071484375px 2025.3742187500002px',
								'2238.1531250000003px 1961.14453125px',
								'2323.845703125px 1892.564453125px',
								'2407.659375px 1802.463671875px',
								'2407.659375px 1802.463671875px',
								'2520.4949218750003px 1590.0171875px',
								'2537.6218750000003px 1538.5929687500002px',
								'2572.97421875px 1373.119140625px',
								'2592.298046875px 1235.554296875px',
								'2611.07265625px 1110.303515625px',
								'2620.857421875px 1034.366796875px',
								'2630.6277343750003px 960.64140625px',
								'2635.23828125px 895.89140625px',
								'2639.3140625px 830.0285156250001px',
								'2639.3140625px 793.4765625px',
								'2639.3140625px 744.4515625px',
								'2639.3140625px 708.9835937500001px',
								'2642.855078125px 679.2101562500001px',
								'2645.861328125px 655.13125px',
								'2651.3390625px 635.662890625px',
								'2657.886328125px 603.721484375px',
								'2664.43359375px 573.948046875px',
								'2667.974609375px 556.2140625000001px',
								'2687.948828125px 512.666796875px',
								'2698.904296875px 493.1984375px',
								'2715.5398437500003px 466.966015625px',
								'2735.181640625px 443.73984375000003px',
								'2754.8234375px 420.513671875px',
								'2768.78515625px 404.05156250000005px',
								'2781.142578125px 391.665234375px',
								'2793.5px 379.27890625000003px',
								'2804.80234375px 370.419140625px',
								'2812.578125px 362.614453125px',
								'2818.402734375px 354.809765625px',
								'2824.2273437500003px 347.005078125px',
								'2830.5867187500003px 335.673828125px',
								'2836.411328125px 327.869140625px',
								'2844.187109375px 322.015625px',
								'2847.5257812500004px 316.69687500000003px',
								'2851.413671875px 312.79453125000003px',
								'2854.2175781250003px 311.378125px',
								'2855.359375px 310.221875px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</Interactive.Div>
	);
};

const TimelineSourceOnlyTrimWideCompositionContent = () => {
	const {width, height} = useVideoConfig();

	return (
		<CloseUpFrame>
			<div
				style={{
					position: 'absolute',
					width: 1920,
					height: 1080,
					left: '50%',
					top: '50%',
					translate: '-50% -50%',
					scale: Math.min(width / 1920, height / 1080),
					overflow: 'hidden',
				}}
			>
				<TimelineSourceOnlyTrimWideContent />
			</div>
		</CloseUpFrame>
	);
};

export const TimelineSourceOnlyTrimWideComposition = Interactive.create({
	Component: TimelineSourceOnlyTrimWideCompositionContent,
	layout: 'absolute-fill',
	schema: {},
});
